import { initApiClient, apiClient, getApiClient } from '@src/shared/types/api-client'
import { AxiosError } from 'axios'

export const interceptError = (setError: (error: AxiosError) => void) => {
  initApiClient(setError)
}

export { apiClient, getApiClient }
